<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mahin was born and raised in Portland, Oregon. She’s been writing since she was a child. <em>BadLands</em> was written when she was 15. This is her first novel. You can find her drowned in a book or watching <em>Lord of the Rings</em> religiously.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?a932f99c